import { z } from "zod"

export const AllDayAnnualConsumptionSchema = z.object({
    allDay: z.number(),
})

export const PeakOffPeakAnnualConsumptionSchema = z.object({
    offPeak: z.number(),
    peak: z.number(),
})

export const SeasonalAllDayAnnualConsumptionSchema = z.object({
    allDaySummer: z.number(),
    allDayWinter: z.number(),
})

export const SeasonalPeakOffPeakAnnualConsumptionSchema = z.object({
    offPeakSummer: z.number(),
    offPeakWinter: z.number(),
    peakSummer: z.number(),
    peakWinter: z.number(),
})
